let discount = [
  {
    path: 'couponManagement',
    meta: {
      title: '优惠券管理',
      breadcrumb: true
    },
    component: {
      name: 'couponManagement',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '', meta: {
          title: '优惠券管理',
        },
        component: (resolve) => require(['@/views/plat/discountManagement/couponManagement'], resolve)
      },
      {
        path: 'newAdd',
        meta: {
          title: "新增",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/discountManagement/couponManagement/children/newAdd'], resolve)
      },
      {
        path: 'editor',
        meta: {
          title: "编辑",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/discountManagement/couponManagement/children/editor'], resolve)
      },
      {
        path: 'couponData',
        meta: {
          title: "数据",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/discountManagement/couponManagement/children/couponData'], resolve)
      }
    ]
  },
  {
    path: 'couponLssue',
    meta: {
      title: '优惠券发放',
      breadcrumb: true
    },
    component: {
      name: 'couponLssue',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',meta: {
          title: '优惠券发放',
        },
        component: (resolve) => require(['@/views/plat/discountManagement/couponLssue'], resolve)
      },
      {
        path: 'newAddLssue',
        meta: {
          title: "新建发放",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/discountManagement/couponLssue/children/newAddLssue'], resolve)
      },
      {
        path: 'lssueRecord',
        meta: {
          title: "发放记录",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/discountManagement/couponLssue/children/lssueRecord'], resolve)
      },
      {
        path: 'userLssue',
        meta: {
          title: "用户发放",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/discountManagement/couponLssue/children/userLssue'], resolve)
      },
      {
        path: 'couponLssue',
        meta: {
          title: "发放管理",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/discountManagement/couponLssue/children/couponLssue'], resolve)
      }
    ]
  },
  {
    path: 'cashCard',
    meta: {
      title: '现金卡',
      breadcrumb: true
    },
    component: (resolve) => require(['@/views/plat/discountManagement/cashCard'], resolve)
  },
  {
    path: 'cardActivation',
    meta: {
      title: '卡激活',
      breadcrumb: true
    },
    component: (resolve) => require(['@/views/plat/discountManagement/cardActivation'], resolve)
  },
]

export default {
  path: '/discountManagement',
  redirect: '/discountManagement/couponManagement',
  meta: {
      title: "优惠管理",
      breadcrumb: true
  },
  component: {
      name: 'discountManagement',
      template: '<router-view></router-view>'
  },
  children: discount
}


// WEBPACK FOOTER //
// ./src/router/discount.js